import {ChangeDetectionStrategy, Component, inject, input, output} from "@angular/core";
import {bzIconSettingsOutline} from "@bringoz/ui/icons";
import {PanelService} from "../../services/panel.service";
import {packageDetailsTableColumns} from "../../../constants/package-details-table-columns.const";
import {
  PackageDetailsSettings, PackageDetailsSettingsPanelContentComponent, PackageDetailsSettingsPanelData,
} from "../package-details-settings-panel-content/package-details-settings-panel-content.component";

@Component({
  selector: "app-package-details-settings-panel",
  templateUrl: "./package-details-settings-panel.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageDetailsSettingsPanelComponent {
  readonly settings = input.required<PackageDetailsSettings>();
  readonly settingsChange = output<PackageDetailsSettings>();

  readonly icon = bzIconSettingsOutline;

  private readonly panelService = inject(PanelService);

  onOpen(event: MouseEvent): void {
    const data: PackageDetailsSettingsPanelData = {settings: this.settings(), defaultColumns: packageDetailsTableColumns};
    const panel = this.panelService.open(PackageDetailsSettingsPanelContentComponent, event, data, {
      position: {originX: "start", originY: "bottom", overlayX: "start", overlayY: "top"},
    });
    panel?.afterClose$.subscribe((settings: PackageDetailsSettings | undefined | null) => {
      if (settings) {
        this.settingsChange.emit(settings);
      }
    });
  }
}
